import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Head from "../../Head/Head";
import NavBar from "../../NavBar/NavBar";
import ContactUs from "../../Forms/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import Prefer from "../../Prefer/Prefer";
import Offices from "../../Offices/Offices";
import InstantQuote from "../../InstantQuote/InstantQuote";

import HeroImg from "../../../images/template-hero.png";
import HeroBanner from "../../../images/template-hero.jpg";

import LanguagesContents from "../../../data/languages";

import "./SimultaneousTemplate.css";

const SimultaneousTemplate = ({ language, location }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const languageType = language
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  const locationCap = location
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  useEffect(() => {
    const checkLanguage = (lang) => {
      return lang.name.toLowerCase() === languageType.toLowerCase();
    };
    if (LanguagesContents.find(checkLanguage)) setOpen(true);
    else history.replace("/404");
  }, [history, languageType]);

  return (
    <>
      {open && (
        <div className="template position-relative">
          <Head
            title={`${languageType} simultaneous interpretation services in ${locationCap} | certified ${languageType} interpreters in ${locationCap}`}
            description={`Get ${languageType} simultaneous interpretation services in ${locationCap} with top certified ${languageType} interpreters in ${locationCap}. We offer ${languageType} simultaneous interpretation services in ${locationCap} in over 250 languages.`}
            keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations, ${languageType}, ${locationCap}`}
          />
          <NavBar />
          <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
            <div className="f-50 my-40">
              <div className="d-flex flex-column align-start justify-center">
                <h2 className="font-heading text-capitalise">
                  Professional {languageType} simultaneous conference
                  interpretation at Your Finger Tips
                </h2>
                <p className="font-bigger mt-40">
                  We provide {languageType} simultaneous conference
                  interpretation at the most professional level bearing client
                  specifics and interest at the core of our services.
                </p>
                <a
                  href="/quote"
                  className="template__link mt-40 py-10 px-20 font-bold"
                >
                  REQUEST A QUOTE
                </a>
              </div>
            </div>
            <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
              <img className="d-flex" src={HeroImg} alt="" />
            </div>
          </div>
          <img className="template__banner my-20" src={HeroBanner} alt="" />
          <div className="template__sec1 container d-flex flex-column align-center justify-between">
            <div className="">
              <h2 className="font-heading">
                {languageType} Interpretation Services
              </h2>
              <p className="my-40 lh-lg font-heavy">
                With the growing trend of simultaneous conference interpretation
                services in {locationCap}, Oneconverse offers a wide range of
                simultaneous interpreting services in {locationCap}. Oneconverse
                is an award winning interpreting agency with over 15 years of
                experience in conference interpretation services in
                {locationCap}.Oneconverse is one of the most respected
                interpreting agencies in {locationCap} for conference
                interpreters. They offer professional, experienced and skilled
                interpreters for all types of conferences and events with highly
                skilled language professionals.{" "}
              </p>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse is a conference interpretation service based in
                {locationCap}. It offers simultaneous conference interpretation
                services for conferences, events, ceremonies and international
                meetings. It offers simultaneous conference interpretation
                services in all languages, with the option to have the
                interpreter on site or remotely through video/teleconference.{" "}
              </p>
              <p className="my-40 lh-lg font-heavy">
                The main goal of Oneconverse is to offer turnkey solutions for
                clients looking for simultaneous conference interpreting
                services. To help them meet these goals, they've developed an
                innovative software solution that automates and streamlines
                processes.{" "}
              </p>
              <a
                href="/quote"
                className="template__link my-40 py-10 px-20 font-bold"
              >
                REQUEST A QUOTE
              </a>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Simultaneous Conference interpreters in {locationCap}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  There are many reasons why simultaneous conference
                  interpretation is becoming a popular choice for large-scale
                  meetings. First, it provides a cost-effective way to increase
                  the number of available interpreters. Secondly, it reduces the
                  risk of a language barrier affecting a meeting's
                  success.Language barriers can cause misunderstandings and
                  other communication problems. This puts a strain on the
                  event's schedule and overall success. To avoid this issue,
                  conference interpreters can be hired from freelance companies
                  that specialize in providing simultaneous conference
                  interpretation services in {locationCap} to businesses and
                  other organizations throughout Europe as well as North
                  America.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is a conference interpreting company that can
                  provide interpreters from all over the world for your events.
                  Their interpretation services are available in multiple
                  languages, and they have interpreters from more than 50
                  different countries to fulfill all of your needs.Oneconverse
                  offers a variety of options when it comes to conference
                  interpretation services in {locationCap}. They offer two
                  levels of services:
                </p>
                <ol className="ml-40">
                  <li className="lh-lg font-heavy">
                    <strong>Tier 1:</strong> This service provides professional
                    interpretations for high-level conferences and event
                    meetings, such as board meetings, speeches, panel
                    discussions and other official events. These interpretations
                    are delivered in a fast turnaround time with minimal
                    conversational pauses between speakers.
                  </li>
                  <li className="lh-lg font-heavy">
                    <strong>Tier 2:</strong> This service is ideal for smaller
                    or informal events or meetings where there will be limited
                    or no simultaneous interpretation required at all times
                    during the event
                  </li>
                </ol>
                <p className="lh-lg font-heavy">
                  Simultaneous interpretation is a process in which someone
                  translates speech from one language to another in real time.
                  For example, when a person in the UK speaks to someone in
                  France, they would receive a translation of their words and
                  vice versa.Oneconverse is one of the leading Simultaneous
                  Conference Interpreters in {locationCap} that has been
                  providing services for over 20 years. Oneconverse provides
                  interpreters who can speak more than 40 languages with an
                  average of 8 years experience. They provide high quality
                  professional conference interpretation services for all kinds
                  of events including conferences, international summits,
                  seminars, congresses and trade shows.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Oneconverse offers competitive conference interpretation rates
                  In {locationCap}
                </h2>
                <p className="lh-lg font-heavy">
                  Simultaneous interpretation is a translation method in which a
                  live speaker (the source) speaks simultaneously into two or
                  more microphones and the translation is simultaneously
                  broadcast over loudspeakers. It is used for communication
                  among people who do not share a common spoken language.{" "}
                </p>
                <h3 className="font-bigger py-40">
                  Simultaneous interpreting services can be used for various
                  purposes such as:
                </h3>
                <ul className="lh-lg font-heavy pl-20">
                  <li>Business meetings and negotiations</li>
                  <li>Conference and presentation sessions</li>
                  <li>
                    Dealing with crowds of people that need an interpreter
                  </li>
                </ul>
                <p className="lh-lg font-heavy">
                  With Oneconverse, you can get top Simultaneous Conference
                  interpreters in {locationCap} from just £24.99 an hour. All
                  Oneconverse Interpreters are vetted to ensure they meet
                  professional standards and have the skills needed to translate
                  your conference into their language of choiceSimultaneous
                  interpretation services in {locationCap} are becoming
                  increasingly popular among conference attendees. These
                  services are very helpful when there is not enough time for a
                  conference interpreter to translate or understand the content
                  of a conference into one's chosen language. With this service,
                  there is no need for conference attendees to learn another
                  language during an event. Instead, they can get top
                  Simultaneous Conference interpreters in {locationCap} from
                  just £24.99 an hour with fast turnaround times .
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Wide Range of Languages Covered in our simultaneous
                  interpretation services in {locationCap}
                </h2>
                <p className="lh-lg font-heavy">
                  We offer simultaneous interpretation services in more than 250
                  languages for conferences and meetings.With our experience of
                  over 15 years, we provide the industry’s widest range of
                  simultaneous interpretation services in {locationCap}.Our
                  international conference interpretation services provide a
                  wide range of languages. To view our languages, please click
                  here.In addition, we offer conference interpretation services
                  for those attending conferences in {locationCap}. To view our
                  conference interpretation services{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Our Simultaneous Interpretation Services in {locationCap}{" "}
                  cover the following languages:
                  <br />
                  English, Russian, Spanish, {languageType}, Portuguese, German,
                  Arabic, Hindi and over 250 languages. We offer simultaneous
                  interpretation services in {locationCap} in nearly all
                  langauges.As the world becomes more interconnected, it is
                  becoming more important to provide simultaneous
                  interpretations services that are available in multiple
                  languages.As a leading simulatenous interpretation company in{" "}
                  {locationCap}, we offer simultaneous interpretation services
                  for both conferences and meetings. Our interpreters are
                  qualified professionals who can adapt their translation skills
                  according to the requirements of the meeting or conference.
                </p>
                <p className="lh-lg font-heavy">
                  We provide a wide range of simultaneous interpretation
                  services in {locationCap}. Our conference interpreting
                  services cover a large number of languages, including Spanish,
                  Mandarin, Russian and Arabic.Our conference interpreting
                  services cover a wide range of languages and we have many
                  professional interpreters that can translate in over 250
                  different languages. We also provide translations for
                  meetings, press conferences and board meetings. Our conference
                  translation service can be found in an array of venues across
                  the city; from the majestic surroundings of the British Museum
                  to the central location of Bloomberg's offices at 20 Fenchurch
                  Street.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  The conference interpreting service is widely used by
                  companies who need to communicate with foreign customers or
                  employees onsite during their visit to {locationCap}. It
                  allows them to use their own language whilst communicating
                  with each other in English - making things much easier for
                  both parties involved{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Our team of simultaneous conference Interpreters in{" "}
                  {locationCap}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is a conference interpreting company based in
                  {locationCap} with 5,000 simultaneous interpreters on staff.
                  With this amount of people on staff, they can provide
                  simultaneous conference interpretation services for any
                  event.The company provides conventional and digital services
                  that include event hosting, audio-visual production,
                  transportation, interpreting booths and more. The company's
                  motto is to “Be the Best at What You Do”Oneconverse is one of
                  the largest conferences interpreting companies in{" "}
                  {locationCap}. They have been in business since 2005 and they
                  have branches in Belgium and Bulgaria{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is a leading conference interpretation agency in
                  {locationCap}. They offer full service of simultaneous
                  interpretation services for all types of conferences.We are
                  the only company that offers both full-language interpretation
                  and simultaneous interpretation services all in one place. We
                  have 5,000 conference interpreters in {locationCap}, which
                  means we are able to provide you with the best service
                  possible.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Many people think that it’s not possible to hire a single
                  company for both types of interpreting services at the same
                  time, but Oneconverse has found a way to make this work.
                  Simultaneous interpreting services are something that can be
                  hard to find, so if you're looking for an interpreter for your
                  conference please contact us
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  At Oneconverse, we have a team of 5,000 conference
                  interpreters in {locationCap}.{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  It’s a large part of our business and a critical part of our
                  role as a global conference interpreter service provider. We
                  provide simultaneous interpretation services for conferences,
                  corporate meetings and events across the world. Our
                  interpreters are highly-skilled professionals with excellent
                  command of language and cultural knowledge of the region they
                  are from.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is an international simultaneous conference
                  interpretation firm that employs 5,000 simultaneous
                  interpreters in {locationCap}.Oneconverse prides itself on
                  quality and effectiveness of its services. It is committed to
                  providing professional, confidential and reliable interpreting
                  services for all your conferences.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Efficient Simultaneous Conference Interpretation services in
                  {locationCap}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is an interpretation agency that provides
                  simultaneous interpreting services in {locationCap}.
                  Oneconverse uses its expertise to ensure that its
                  interpretation services are efficient and reliable.Oneconverse
                  offers a fully digital interpretation experience, which means
                  that they can provide translations of any kind of content for
                  you anytime, anywhere.Oneconverse has partnered with brands
                  like BBC World News and New York Times to make sure your
                  message gets across the world in the best possible way.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  The value of oneconverse's service is indicated by some of its
                  clientele. For example, the BBC World News brand has partnered
                  with them for over two decades to provide simultaneous
                  interpreting services at their events.British Airways has also
                  hired Oneconverse on multiple occasions to provide
                  simultaneous interpretations at their events too.Oneconverse
                  is a trusted simultaneous interpreting agency that provides
                  conference interpretation services in {locationCap}.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers professional simultaneous interpreting
                  services to many companies and organizations all around the
                  world. Their team has strong customer service and dedication
                  to excellence. They also provide professional, economical and
                  trusted services. When a conference is held with a lot of
                  participants, simultaneous interpretation services is often
                  the only way to ensure that all speakers are heard.
                </p>
                <p className="lh-lg font-heavy">
                  In {locationCap}, Simultaneous Conference Interpretation is an
                  increasingly competitive field, with many providers offering
                  their services. Newcomers to the market may find it difficult
                  to establish themselves as reliable providers for this
                  service. Oneconverse was founded in 2008 and has been
                  providing trusted simultaneous interpretation services in
                  {locationCap} since then. Simultaneous interpreting is an
                  interpretation service where two different languages are
                  interpreted simultaneously. {locationCap} has a large number
                  of simultaneous interpreting services available for foreign
                  visitors, but they can be hard to navigate through.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is the only one that offers trusted simultaneous
                  interpretation services in {locationCap}. They offer their
                  clients high quality services with affordable prices.
                  Oneconverse also offers customer support 24/7 and free
                  consultations on all requests of simultaneous interpretation
                  services in
                  {locationCap}!Oneconverse uses their own interpreters for
                  meeting rooms, events and conferences in {locationCap}. They
                  have a diverse team of experienced interpreters who provide
                  the best service possible in each location they visit.
                </p>
                <p className="lh-lg font-heavy">
                  Simultaneous interpretation services in {locationCap} are
                  becoming more and more popular. Oneconverse offers trusted
                  simultaneous interpretation services in the city. They have
                  bilingual interpreters who provide their services 24 hours a
                  day, 365 days a year, to make sure your meetings are
                  successful.Oneconverse provides different types of
                  interpreting services like video conference interpretation,
                  telephone conference interpretation, text conference
                  interpretation or face-to-face conference interpretation.
                  Oneconverse is also present in over 27 countries across the
                  world with its offices in the US and UK.
                </p>
                <p className="lh-lg font-heavy">
                  Efficient Simultaneous Conference Interpretation services in
                  {locationCap} are necessary to make sure that the conference
                  goes smoothly. Oneconverse offers reliable assistance for
                  conference interpreters by providing simultaneous
                  interpretation services in {locationCap}.A conference
                  interpreter is the person who translates what other people are
                  saying into an understandable language while it is being said
                  at the meeting. The conference interpreter ensures that
                  everyone at the meeting understands what other people are
                  saying. When there is an interpreter, it creates a more
                  immersive experience for the meeting attendees.There are many
                  reasons why you should consider using Oneconverse’s service,
                  which includes offering high-quality simultaneous interpreting
                  services in {locationCap} and getting competitive pricing.
                </p>
                <p className="lh-lg font-heavy">
                  This is a professional conference interpreting services
                  provider in {locationCap} who offers high-quality simultaneous
                  interpretation services. They have been offering these
                  services for over 20 years now.Simultaneous Conference
                  Interpreting is an essential tool for any company that needs
                  to conduct simultaneous communication with their overseas
                  colleagues. Oneconverse offers the best simultaneous
                  interpreting services in {locationCap}.Simultaneous
                  interpreting is a technique that allows two or more people to
                  speak and hear the conversation at the same time. It is often
                  used in international business meetings and conferences in
                  order to facilitate communication between participants.
                </p>
                <p className="lh-lg font-heavy">
                  The main aim of simultaneous interpretation services in{" "}
                  {locationCap}
                  is to provide an efficient and reliable service for conference
                  interpretation. Oneconverse does this by providing
                  personalized, friendly, professional, flexible and
                  cost-effective conference interpreters for conferences,
                  meetings, seminars etc.Oneconverse is a trusted conference
                  interpretation service in {locationCap} providing quality
                  simultaneous interpreting services for conferences, meetings
                  and other events.Oneconverse has been assisting companies and
                  organizations with their conference interpretation needs since
                  2007 and we would like to share our expertise with you. We
                  help people all over the world not only at conferences but
                  also during meetings, phone conferences, webinars and many
                  other events. With this said, we hope to give you an insight
                  on how to get the most out of your conference interpreting
                  experience, so that you can get the most out of your event or
                  audience participation.
                </p>
                <p className="lh-lg font-heavy">
                  The art of simultaneous interpreting is difficult enough
                  without the added pressure of having to interpret in a foreign
                  language without any context or background information.
                  Oneconverse offers trusted simultaneous interpreting services
                  in {locationCap} which lets you focus onOneconverse is an
                  Efficient Simultaneous Conference Interpretation Services
                  Provider in
                  {locationCap}. They provide affordable, high quality
                  simultaneous interpreting services for your conference.The
                  most important feature of Oneconverse is that they are a
                  trusted interpretation service provider. They have been
                  providing interpretation services since 2002 and have only
                  seen the satisfaction levels go up over the years. Their
                  clients include Fortune 500 companies, global governments, IT
                  organizations and language schools among many
                  others.Oneconverse also offers customized interpreter
                  placement service for your meetings. Simultaneous conference
                  interpretation services in {locationCap} with a skillful
                  experienceSimultaneous interpretation setting
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Benefits of Outsourcing {languageType} Interpretation Services
                  To Oneconverse
                </h2>
                <p className="lh-lg font-heavy">
                  The process of {languageType} interpretation is quite
                  expensive. However, the benefits of outsourcing {languageType}{" "}
                  Interpretation services to Oneconverse are quite evident. They
                  can provide high-quality {languageType} at a cheaper
                  price.Outsourcing is widely used in numerous industries, and
                  it includes professional services as well as manufacturing.
                  People can easily find plenty of examples where they can see
                  how it has helped companies save money on hiring human
                  translators.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers {languageType} interpretation services for
                  an affordable price without compromising on quality or
                  accuracy. Having a oneconverse interpreting service will help
                  you reduce the risk of errors in your translated content
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Types of Simultaneous conference Interpretation services in
                  {locationCap}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  Simultaneous interpreting is a highly skilled job that
                  requires the person to have a sound knowledge of English
                  language and culture.Oneconverse has been providing
                  simultaneous interpretation services in {locationCap} for a
                  decade. With a decade of experience, we have the expertise in
                  the industry and can offer different types of simultaneous
                  interpretation services in {locationCap} - conference
                  interpretation services, meetings interpretation services,
                  one-to-one interpreting services.{" "}
                </p>
                <ul className="lh-lg font-heavy pl-40">
                  <li>On-site simultaneous interpretation</li>
                  <li>Conference Interpretation Services</li>
                  <li>Remote Simultaneous interpreting</li>
                  <li>Zoom simultaneous interpretation</li>
                  <li>Whispered interpreting</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Additional Translation Services to support your Conference{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  In the age of globalization, it is essential for companies to
                  reach out to global markets. In order to do that, they need an
                  international team of skilled translators and interpreters. We
                  at Oneconverse Translation Services {locationCap} provide
                  conference interpretation services in {locationCap}.Our
                  translation service is a great way to make sure your
                  conference is a success!The Simultaneous Interpretation
                  service offers simultaneous translation into over 250
                  languages. This service is ideal for any conference or event
                  that requires simultaneous interpretation in different
                  languages. The interpreter’s voice will be heard by the person
                  speaking in the target language while the speaker’s voice is
                  translated into their language of choice.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  We offer additional translation services to support your
                  conference or event. We provide services in both English and
                  Spanish, so you can ensure your participants are able to
                  listen and follow along with what you are saying, no matter
                  what language they speak. Our professional interpreters will
                  ensure that you have a successful event with minimal
                  disruption to your attendees{" "}
                </p>
              </div>
            </div>
          </div>
          <Prefer />
          <Offices />
          <ContactUs />
          <div className="container">
            <InstantQuote />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default SimultaneousTemplate;
